import { render } from "./Product.vue?vue&type=template&id=1ae6270e&scoped=true"
import script from "./Product.vue?vue&type=script&lang=js"
export * from "./Product.vue?vue&type=script&lang=js"

import "./Product.vue?vue&type=style&index=0&id=1ae6270e&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-1ae6270e"

export default script